import {useEffect} from 'react';
import type {MutableRefObject} from 'react';

type OutsideClickRef = MutableRefObject<HTMLElement | null>;

const useOnClickOutside = (
  ref: OutsideClickRef,
  handler: (event: MouseEvent) => void,
  exceptions?: OutsideClickRef[]
) => {
  useEffect(() => {
    const exceptionRefs = exceptions ?? [];

    const listener = (event: MouseEvent) => {
      const targetNode = event.target as Node | null;
      if (
        !ref.current ||
        !targetNode ||
        ref.current.contains(targetNode) ||
        exceptionRefs.some(exception => exception.current?.contains(targetNode))
      ) {
        return;
      }
      handler(event);
    };

    document.addEventListener('click', listener);

    return () => {
      document.removeEventListener('click', listener);
    };
  }, [ref, handler, exceptions]);
};

export default useOnClickOutside;
